<template>
  <CFlex inline v-tooltip="tooltip">
    <CIcon name="person"/>
    <COrderStatusIcon :status="job.order.status" :hasSignature="job.order.hasSignature"/>
  </CFlex>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import CTooltipImageContent from '@/general/components/tooltip/CTooltipImageContent.vue';
  import AuthService from '@/general/services/AuthService';
  import ReferenceService from '@/general/services/ReferenceService';
  import CFlex from '@/shared/components/CFlex.vue';
  import CIcon from '@/shared/components/CIcon.vue';
  import Permission from '@/shared/constants/Permission';
  import { formatDateTime } from '@/shared/utils/dateTime';
  import { isPresent } from '@/shared/utils/typescript';
  import Job from '../../models/Job';
  import { getOrderStatusLabel } from '../../utils/labels';
  import COrderStatusIcon from './COrderStatusIcon.vue';

  const props = defineProps<{
    job: Job;
  }>();

  const i18n = useI18n();

  const tooltip = computed(() => {
    const order = props.job.order;
    const registeredById =  order?.registeredBy?.id;
    const registeredBy = isPresent(registeredById) && ReferenceService.getActiveUsers().find(u =>  u.id === registeredById)?.fullName;
    let text = getOrderStatusLabel(order.status);
    if (order.orderedBy) {
      const params = {
        orderedBy: order.orderedBy.fullName,
        orderedOn: formatDateTime(order.orderedOn) || '?',
      };
      text += ` - ${i18n.t('orderStatus.ByOn', params)}`;
    }
    if (registeredBy) {
      text += ` - ${i18n.t('orderStatus.registeredBy', { registeredBy })}`;
    }
    if (order.signature && AuthService.getCurrentUser().hasPermission(Permission.ACCESS_TO_CONTACTS_DETAILS)) {
      return { component: CTooltipImageContent, props: { url: order.signature, title: text } };
    } else {
      return text;
    }
  });
</script>